module.exports = __webpack_public_path__ + "img/chevron-up.2d39d1a4.png";